function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PlayerboxTemplate = require('./playerbox.template');
var Playerbox = /*#__PURE__*/function () {
  function Playerbox(app, mod) {
    var _mod$game;
    var publicKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var player_number = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    _classCallCheck(this, Playerbox);
    this.app = app;
    this.mod = mod;
    this.publicKey = publicKey;
    this.player_number = player_number;
    var character = this.resolveCharacter();
    this.character_id = character;
    this.character_src = "/poker/img/players/".concat(character, ".png");
    this.name = player_number > 0 && (_mod$game = mod.game) !== null && _mod$game !== void 0 && (_mod$game = _mod$game.state) !== null && _mod$game !== void 0 && _mod$game.player_names ? mod.game.state.player_names[player_number - 1] : mod.app.keychain.returnUsername(publicKey);
    this.role = '';
    this.action = '';
    this.chips_html = '';
  }
  return _createClass(Playerbox, [{
    key: "resolveCharacter",
    value: function resolveCharacter() {
      var _this$mod$game;
      if (this.player_number > 0 && typeof this.mod.ensurePlayerCharacters === 'function') {
        this.mod.ensurePlayerCharacters();
      }
      var chars = (_this$mod$game = this.mod.game) === null || _this$mod$game === void 0 || (_this$mod$game = _this$mod$game.state) === null || _this$mod$game === void 0 ? void 0 : _this$mod$game.player_characters;
      if (this.player_number > 0 && Array.isArray(chars) && chars[this.player_number - 1]) {
        return chars[this.player_number - 1];
      }
      // Observer / fallback seat: pick an unused portrait when possible.
      var pool = typeof this.mod.returnPlayerCharacterPool === 'function' ? this.mod.returnPlayerCharacterPool() : ['player1', 'player2', 'player3', 'player4', 'player5', 'player6'];
      var used = new Set(Array.isArray(chars) ? chars : []);
      return pool.find(function (id) {
        return !used.has(id);
      }) || pool[0];
    }
  }, {
    key: "render",
    value: function render(container) {
      if (document.querySelector(".game-playerbox-".concat(this.player_number))) {
        this.app.browser.replaceElementBySelector(PlayerboxTemplate(this), ".game-playerbox-".concat(this.player_number));
      } else {
        this.app.browser.addElementToSelector(PlayerboxTemplate(this), container);
      }
      this.setRole(this.role);
    }
  }, {
    key: "remove",
    value: function remove() {
      var el = document.querySelector(".game-playerbox-".concat(this.player_number));
      if (el) {
        el.remove();
      }
    }
  }, {
    key: "addClass",
    value: function addClass(classname) {
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'game-playerbox';
      var el = document.querySelector(".".concat(target, "-").concat(this.player_number));
      if (el) {
        el.classList.add(classname);
      }
    }
  }, {
    key: "setRole",
    value: function setRole(role) {
      this.role = role || '';
      var el = document.querySelector(".game-playerbox-".concat(this.player_number));
      if (!el) {
        return;
      }
      el.classList.remove('dealer', 'small-blind', 'big-blind', 'winner');
      delete el.dataset.blind;
      var text = String(this.role);
      if (text.includes('Winner')) {
        el.classList.add('winner');
      }
      if (text.includes('dealer')) {
        el.classList.add('dealer');
      }
      if (text.includes('small blind')) {
        el.classList.add('small-blind');
        el.dataset.blind = 'small';
      }
      if (text.includes('big blind')) {
        el.classList.add('big-blind');
        el.dataset.blind = 'big';
      }
    }
  }, {
    key: "setChips",
    value: function setChips(html) {
      this.chips_html = html || '';
      var el = document.querySelector(".game-playerbox-".concat(this.player_number, " .playerbox-chips"));
      if (el) {
        el.innerHTML = this.chips_html;
      }
    }
  }, {
    key: "setAction",
    value: function setAction(action) {
      this.action = action || '';
      var el = document.querySelector(".game-playerbox-".concat(this.player_number, " .playerbox-action"));
      if (el) {
        el.innerHTML = this.action;
      }
    }
  }, {
    key: "updateUserline",
    value: function updateUserline(userline) {
      this.setRole(userline);
    }
  }, {
    key: "updateIcons",
    value: function updateIcons(content) {
      this.setChips(content);
    }
  }, {
    key: "updateBody",
    value: function updateBody(content) {
      this.setAction(this.strip(content));
    }
  }, {
    key: "updateGraphics",
    value: function updateGraphics(content) {
      var el = document.querySelector(".game-playerbox-graphics-".concat(this.player_number));
      if (el) {
        el.innerHTML = content;
      }
    }
  }, {
    key: "replaceGraphics",
    value: function replaceGraphics(content, selector) {
      var pb_selector = ".game-playerbox-graphics-".concat(this.player_number);
      if (document.querySelector(pb_selector)) {
        if (document.querySelector("".concat(pb_selector, " ").concat(selector))) {
          this.app.browser.replaceElementBySelector(content, "".concat(pb_selector, " ").concat(selector));
        } else {
          this.app.browser.addElementToSelector(content, pb_selector);
        }
      }
      return "".concat(pb_selector, " ").concat(selector);
    }
  }, {
    key: "strip",
    value: function strip(html) {
      if (!html) {
        return '';
      }
      return String(html).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    }
  }]);
}();
module.exports = Playerbox;